// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__28aEZ","buttons":"PendingPaymentAlert_buttons__3xi3t"};